<template>
  <v-container
    id="users-view"
    fluid
    tag="section"
  >
    <material-card
      dark
      icon="mdi-clipboard-text"
      icon-small
      title="Users"
      color="accent"
    >
      <template v-slot:headActions>
        <app-btn
          color="primary"
          dark
          class="ml-2"
          to="/users/new"
        >
          {{ $t('New User') }}
        </app-btn>
      </template>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="users"
      >
        <template v-slot:body="{ items }">
          <item
            v-for="item in items"
            :key="item.id"
            :item="item"
          />
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Item from '@/components/Roles/Item'

  export default {
    name: 'Users',
    components: {
      Item,
    },
    data: () => ({
      loading: false,
      headers: [
        { text: 'ID', align: 'center', width: '20%', value: 'id' },
        { text: 'Name', align: 'center', width: '20%', value: 'name' },
        { text: 'Action', align: 'center', width: '20%', sortable: false, value: '' },
      ],
    }),
    computed: {
      ...mapGetters({
        users: 'admin/getUsers',
      }),
    },
    mounted () {
      this.loading = true
      this.loadUsersList()
        .finally(() => {
          this.loading = false
        })
    },
    methods: {
      ...mapActions({
        loadUsersList: 'admin/loadUsers',
      }),
    },
  }
</script>
